"use strict";

/**
 * Cleans URL after removing or adding refinements
 * and normalize the prefn and prefv parameters counter
 *
 * @param {String} url url to clean
 * @returns {String} clean url
 */
function cleanURL(url) {
    url = url.replace("?&", "?").replace("??", "?");

    // reorder the refinements
    const parsedURL = url.split("?");
    const queryParams = parsedURL.length > 1 ? parsedURL[1].split("&") : null;
    let cleanUrl = parsedURL[0];

    if (queryParams.length && queryParams[0] !== "") {
        cleanUrl += "?";
        let paramCounter = 1;

        for (let i = 0; i < queryParams.length; i++) {
            let param = queryParams[i];

            if (!param) {
                continue;
            }

            const arParam = param.split("=");

            if (i > 0) {
                cleanUrl += "&";
            }

            if (param.indexOf("prefn") > -1) {
                cleanUrl += "prefn" + paramCounter + "=" + arParam[1];
            } else if (param.indexOf("prefv") > -1) {
                cleanUrl += "prefv" + paramCounter + "=" + arParam[1];
                paramCounter++;
            } else {
                cleanUrl += param;
            }
        }
    } else {
        return cleanUrl.replace("?", "");
    }

    return cleanUrl;
}


/**
* Cleans the given URL by removing any query parameters that match the specified refinement ID.
*
* @param {string} url - The URL to be cleaned.
* @param {string} refinementIdToRemove - The refinement ID to be removed from the URL"s query parameters.
* @returns {string} The cleaned URL with the specified refinement ID removed from the query parameters.
**/
function removeRefinementFromURL(url, refinementID) {
    let strUrl = typeof url === "string" ? url : url.toString();

    if (!refinementID || !url || strUrl.indexOf("?") === -1 || strUrl.indexOf("&") === -1) {
        return url;
    }

    const parsedURL = strUrl.split("?");
    const queryParams = parsedURL[1].split("&");
    let removeNextRefinementValue = false;

    for (let i = 0; i < queryParams.length; i++) {
        let param = queryParams[i];

        if (removeNextRefinementValue) {
            strUrl = strUrl.replace("&" + param, "").replace("?" + param, "");
            removeNextRefinementValue = false;
            continue;
        }

        if (param.indexOf("prefn") > -1 && param.indexOf(refinementID) > -1) {
            strUrl = strUrl.replace(param, "");
            removeNextRefinementValue = true;
        }
    }

    return cleanURL(strUrl);
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    let newUrl = url;
    newUrl += (newUrl.indexOf("?") !== -1 ? "&" : "?") + Object.keys(params).map(function (key) {
        return key + "=" + encodeURIComponent(params[key]);
    }).join("&");

    return newUrl;
}

module.exports = {
    removeRefinementFromURL,
    appendToUrl
};
